<template>
	<div class="apparatusList">
	    <div class="apparatus-item" v-for="(value) in list" :key="value.id" @click="skipDetails(value.id)">
			<img :src="value.banner" alt="">
		    <span>{{value.name}}</span>
		</div>					
	</div>
</template>
<script>
export default {
    props:{
        list:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{

        }
	},
	methods:{
		//跳转到详情页
		skipDetails(id){
			this.$router.push({
				path:'/instrument/details',
				query:{
						id:id
					}
				})
		}
	}
}
</script>
<style lang="scss" scoped>
    .apparatusList{
		.apparatus-item{
			@include flex(row);
			border-bottom: 1px solid #BFBFBF;
			height:82px;
			align-items:center;
			img{
				width:80px;
				margin-right:12px;
			}
			span{
				font-size: 14px;
				color: #090909;
				letter-spacing: 0.49px;
			}

		}
		.child-item:last-child{
			border:0px;
		}
    }
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/Components/apparatus.vue